import { gql } from '@apollo/client';

export const PROPERTY_LINKS_FRAGMENT = gql`
  fragment PropertyLinks on Property {
    links {
      list {
        id
        name
        url
      }
    }
  }
`;
